import React, { Component } from "react";

export class FormEffect extends Component<any, any> {
    constructor(props) {
        super(props);

        props.onChange && props.onChange(props);
    }

    componentDidMount() {
        const { isValid, validateForm } = this.props;
        if (!isValid) {
            validateForm();
        }
    }

    componentWillReceiveProps(nextProps) {
        nextProps.onChange && nextProps.onChange(nextProps);
    }

    render() {
        return null;
    }
}
